// 游戏模块服务层

import { gameApi } from "../api";
import { GameCategory } from "../types";
import { useGameStore } from "../stores";

// 游戏服务类
export class GameService {
  private static instance: GameService;

  static getInstance(): GameService {
    if (!GameService.instance) {
      GameService.instance = new GameService();
    }
    return GameService.instance;
  }

  // 游戏分类服务
  async loadGameCategories(): Promise<GameCategory[]> {
    const { getCache, setCache } = useGameStore.getState();

    // 检查缓存
    const cacheKey = "game_categories";
    const cached = getCache(cacheKey);
    if (cached) {
      return cached;
    }

    try {
      const data = await gameApi.getGameCategories();

      // 缓存数据
      setCache(cacheKey, data, 30 * 60 * 1000); // 30分钟缓存

      return data;
    } catch (error) {
      console.error("游戏分类加载失败:", error);
      return [];
    }
  }
}

// 创建单例实例
export const gameService = GameService.getInstance();

// 导出便捷方法
export const { loadGameCategories } = gameService;
